import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { Commons } from "../../../utilities";

const HealthMonitoring = ({ loginData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (loginData?.languageAbb && loginData?.userGuid) {
      dispatch(actionPatient.getQuestion1(loginData.languageAbb));
      dispatch(actionPatient.getAnswers1(loginData.userGuid));
    }
  }, [dispatch, loginData?.languageAbb, loginData?.userGuid]);

  const getQuestionData1 = useSelector(
    (state) => state.patient.getQuestionData1?.data?.result || []
  );
  const getAnswersData1 = useSelector(
    (state) => state.patient.getAnswersData1?.data?.result || []
  );

  const labelMappings = {
    0: {
      label1: t("patient_Details.right_eye"),
      label2: t("patient_Details.left_eye"),
    },
    1: { label1: t("patient_Details.alcohol_intake") },
    2: { label1: t("patient_Details.cigarettes_per_day") },
    3: { label1: t("patient_Details.glucose_level") },
    4: {
      label1: t("patient_Details.hba1c"),
    },
    5: { label1: t("patient_Details.fasting_glucose") },
    6: { label1: t("patient_Details.pap_smear_result") },
    7: { label1: t("patient_Details.blood_pressure") },
  };

  return (
    <Container fluid className="exado-container1 ">
      <Row className="exado-row1">
        <Col>
          {getQuestionData1.map((que, index) => (
            <div key={index} className="health-info-que-ans-tab-blk health-monitoring-tab-blk">
              <p className="exado-title-seven health-info-que">
                {que.question}
              </p>
              {getAnswersData1
                .filter((ans) => ans.questionGuid === que.questionGuid)
                .sort(
                  (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
                )
                .map((ans, ansIndex) => (
                  <Row key={ansIndex} className="past-entries-data">
                    <Col md={2}>
                      <span className="past-entries-datalist">
                        {Commons.formatDateWithOrdinal(
                          new Date(ans.createdDate)
                        )}
                      </span>
                    </Col>
                    <Col md={1}>
                      <span className="past-entries-datalist">
                        {new Date(ans.createdDate).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </Col>
                    <Col md={{ span: 2, offset: 2 }}>
                      <span className="past-entries-datalist">
                        {labelMappings[index]?.label1 || ""}: {ans.answer1}
                      </span>
                    </Col>
                    <Col md={2}>
                      <span className="past-entries-datalist">
                        {labelMappings[index]?.label2 && (
                          <>
                            {labelMappings[index].label2}: {ans.answer2}
                          </>
                        )}
                      </span>
                    </Col>
                  </Row>
                ))}
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default HealthMonitoring;
